export default "__VITE_ASSET__Bhz_FAL$__"